// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_style_avatar__nq3_e","avatar--live":"avatar_style_avatar--live__P_doz"};